import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import 'swiper/css';

import dropdown from './dropdown';
import navbarMobile from './navbarMobile';
import accordion from './accordion';
import accordionUnrestricted from './accordionUnrestricted';
import downloadAccordion from './downloadAccordion';
import tab from './tab';
import modal from './modal';
import navigationBar from './navigationBar';
import homeCarousel from './homeCarousel';
import scrollChangingPicture from './scrollChangingPicture';
import showMore from './showMore';
import swiperGallery from './swiperGallery';
import preMadeGraphicSelector from './preMadeGraphicSelector';
import importerCard from './importerCard';
import contactList from './contactList';
import navigationTab from './navigationTab';
import projectSlider from './projectSlider';
import lightbox from './lightbox';
import announcementBar from './announcementBar';
import productInformation from './productInformation';
import boldfix from './boldfix';
import konfigurator from './konfigurator';
import konfiguratorClient from './konfiguratorClient';
import konfiguratorRadiobuttons from './konfiguratorRadiobuttons';
import listingPage from './listingPage';
import checkboxFilterOptionList from './checkboxFilterOptionList';
import downloadSearch from './downloadSearch';
import loadable from './loadable';
import filterCategoryPicker from './filterCategoryPicker';
import submittable from './submittable';
import formInput from './formInput';
import search from './search';
import inspirations from './inspirations';
import blogCategory from './blogCategory';
import vendorLocations from './vendorLocations';
import companySelector from './companySelector';
import cart from './cart';
import notification from './notification';
import suggestedProductFilter from './suggestedProductFilter';

import {
	id,
	getItem,
	validPass,
	validName,
	validEmail,
	validPassword,
	validTaxCode,
	validPhone,
	combineValidation,
	validCompanyName,
} from './utilFunctions';
import iframe from './iframe';
import account from './account';
import login from './login';
import { registerCompany, registerDistributor } from './register';
import imageUpload from './imageUpload';
import logout from './logout';

window.Alpine = Alpine;

Alpine.plugin(focus);

Alpine.data('dropdown', dropdown);
Alpine.data('navbarMobile', navbarMobile);
Alpine.data('tab', tab);
Alpine.data('modal', modal);
Alpine.data('accordion', accordion);
Alpine.data('accordionUnrestricted', accordionUnrestricted);
Alpine.data('downloadAccordion', downloadAccordion);
Alpine.data('navigationBar', navigationBar);
Alpine.data('homeCarousel', homeCarousel);
Alpine.data('scrollChangingPicture', scrollChangingPicture);
Alpine.data('showMore', showMore);
Alpine.data('swiperGallery', swiperGallery);
Alpine.data('preMadeGraphicSelector', preMadeGraphicSelector);
Alpine.data('importerCard', importerCard);
Alpine.data('contactList', contactList);
Alpine.data('navigationTab', navigationTab);
Alpine.data('projectSlider', projectSlider);
Alpine.data('lightbox', lightbox);
Alpine.data('announcementBar', announcementBar);
Alpine.data('productInformation', productInformation);
Alpine.data('boldfix', boldfix);
Alpine.data('konfigurator', konfigurator);
Alpine.data('konfiguratorClient', konfiguratorClient);
Alpine.data('konfiguratorRadiobuttons', konfiguratorRadiobuttons);
Alpine.data('listingPage', listingPage);
Alpine.data('checkboxFilterOptionList', checkboxFilterOptionList);
Alpine.data('downloadSearch', downloadSearch);
Alpine.data('loadable', loadable);
Alpine.data('iframe', iframe);
Alpine.data('filterCategoryPicker', filterCategoryPicker);
Alpine.data('submittable', submittable);
Alpine.data('formInput', formInput);
Alpine.data('search', search);
Alpine.data('inspirations', inspirations);
Alpine.data('blogCategory', blogCategory);
Alpine.data('vendorLocations', vendorLocations);
Alpine.data('companySelector', companySelector);
Alpine.data('cart', cart);
Alpine.data('login', login);
Alpine.data('logout', logout);
Alpine.data('registerCompany', registerCompany);
Alpine.data('registerDistributor', registerDistributor);
Alpine.data('imageUpload', imageUpload);
Alpine.data('notification', notification);
Alpine.data('suggestedProductFilter', suggestedProductFilter);

Alpine.store('account', account);

Alpine.store('transformFunctions', {
	id: id,
	getItem: getItem,
	getData: (x) => x.data,
	getProducts: (x) => x.data.products,
	getAllItems: (x) => x.data.items,
});

Alpine.store('handleResponseFunctions', {
	doNothing: (x) => x,
	printResponse: (resp) => console.log(resp),
	handleSubscribeResponse: (resp) => {
		if (!resp.redirected) {
			return resp.json().then((json) => {
				return json.data
					? { message: json.data.message, success: true }
					: { message: json.message, success: false };
			});
		}
	},
});

Alpine.store('validationFunctions', {
	pass: validPass,
	name: validName,
	companyName: validCompanyName,
	email: validEmail,
	password: validPassword,
	phone: validPhone,
	taxCode: validTaxCode,
	combineValidation: combineValidation,
	id: (x) => x,
	getItem: (n) => (x) => x.data.items[n],
	getProducts: (resp) => resp.data.products,
});

Alpine.store('cartinfo', {
	getCartInfoText: () => 'Ajánlat létrehozása',
});

// Alpine.store('uiUtils', {
// 	scrollBottomDistance: (element) => {
// 		return Math.max(
// 			0,
// 			element.scrollHeight - element.scrollTop - element.clientHeight
// 		);
// 	},
// });
//
Alpine.start();
